import {useContext, useEffect, useRef, useState} from 'react';
import {Link, NavLink, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {
    Badge,
    Button,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Form,
    FormGroup,
    Input,
    Spinner,
    UncontrolledDropdown
} from "reactstrap";
import {BsSearch} from "react-icons/bs";
import {FaRegUser} from "react-icons/fa";
import {X} from "react-feather";
import {connect, useSelector} from "react-redux";
import {isMobile} from "react-device-detect";
import {FormattedMessage} from "react-intl";

import {ContextLayout} from "@layouts/web";
import logoImage from "@assets/images/logo/logo.webp";
import logoImageMobile from "@assets/images/logo/logoLine.webp";
import {urls} from "@api/urls";
import {GetRequest} from "@configs/request";
import DETAILS from "@constants/shopDetails";
import WebPaths from "@router/paths/web";
import PanelPaths from "@router/paths/panel";
import {handleLogout} from "@store/actions/auth";
import DisplayPriceWithLabel from "@components/displayPriceWithLabel";
import {useOnClickOutside} from '@hooks/useOnClickOutside'
import basket from "@assets/icons/basket.webp";
import {productSort} from "@utils/types/productSort";
import {contactMethodsTypes} from "@utils/types/contactMethodsTypes";

import {Index} from "../minBarDown";
import Menu from "../../../menu";
import MobileNavbar from "../../../menu/MobileMenu/Navbar";

import "./style.scss";
import {Chip} from "@material-ui/core";
import {FilterModal} from "../../../../../../../components/modalFilter";

let searchTimeOut;

let isAdvanceSearch = false
const MainBar = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchValue, setSearchValue] = useState("");
    const [isSearching, setIsSearching] = useState("");
    const [quickSearchResults, setQuickSearchResults] = useState([]);
    const [isOpenSearch, setIsOpenSearch] = useState(false);

    const Context = useContext(ContextLayout);
    const navigate = useNavigate();
    const location = useLocation();
    const quickSearchResultsSection = useRef(null);
    const {name} = DETAILS;
    const isAdmin = props?.user?.roles[0] === 'admin' ? true : false

    const token = localStorage.getItem('token') ? localStorage.getItem('token') : '';

    const defaultSearch = searchParams.get('search') || "";

    useEffect(() => {
        if (typeof defaultSearch !== "undefined") {
            setSearchValue(defaultSearch);
        }
    }, []);
    useEffect(() => {
        setQuickSearchResults(false);
        setSearchValue("");
    }, [location.pathname]);

    useEffect(() => {
        if (searchValue) {
            if (searchTimeOut) clearTimeout(searchTimeOut);
            searchTimeOut = setTimeout(() => {
                getQuickSearch();
            }, 1000);
        } else {
            setQuickSearchResults([]);
        }
    }, [searchValue]);

    useOnClickOutside(quickSearchResultsSection, () => {
        setQuickSearchResults(false);
        if (props.externalClick) {
            props.externalClick()
        }
    })

    const getQuickSearch = () => {
        setIsSearching(true);
        GetRequest(urls.web.quickSearch, {search: searchValue})
            .then((response) => {
                if (response) {
                    if (response.ok && response.data) {
                        let result = response.data;
                        setQuickSearchResults(result);
                    }
                }
            })
            .finally(() => {
                setIsSearching(false);
            });
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch();
        }
    }

    const handleSearch = () => {
        if (location.pathname === "/products") {
            let updatedSearchParams = new URLSearchParams(searchParams.toString());

            updatedSearchParams.set("search", searchValue);

            setSearchParams(updatedSearchParams.toString());

            return;
        }

        navigate(WebPaths.products([
            {
                param: "search",
                values: searchValue
            }
        ]));
    }

    const handleResetSearch = () => {
        setSearchValue("");

        if (location.pathname === "/products" && searchParams.get("search")) {
            let updatedSearchParams = new URLSearchParams(searchParams.toString());
            updatedSearchParams.delete("search");

            navigate("/products?" + updatedSearchParams.toString());
        }
    }
    const openSearchHandler = ()=>{
        setIsOpenSearch(!isOpenSearch)
    }

    const logoutAccount = (props) => {
        if (props.user.token)
            props.handleLogout();
    }

    /*const onSearchChange = (value) => {
        const delayDebounceFn = setTimeout(() => {
            setSearchValue(value);
        }, 1500)

        return () => clearTimeout(delayDebounceFn)
    }*/

    const logo = <div className="main-bar-logo d-none d-md-block">
        <NavLink aria-label={name} to={WebPaths.home}>
            <img src={logoImage} alt={name} width="110px"/>
        </NavLink>
    </div>

    const logoMobile = <div className="main-bar-logo">
        <NavLink aria-label={name} to={WebPaths.home}>
            <img src={logoImageMobile} alt={name} width="60px"/>
        </NavLink>
    </div>

    const searchbar = <div className={`main-bar-top-search${isMobile ? " mobile" : ""}`} ref={quickSearchResultsSection}>
        <div className={"w-100"}>
            <Form className="d-flex justify-content-center align-items-center w-100"
                  onClick={(e) => e.preventDefault()}>
                <Button
                    aria-label={"جستجو"}
                    className="main-bar-top-search-submit-button"
                    disabled={!searchValue}
                    onClick={() => handleSearch()}
                >
                    <BsSearch/>
                </Button>
                <FormGroup className='w-100'>
                    <Input
                        type="text" //x icon not working when type is search
                        name="search"
                        placeholder="جستجوی محصول..."
                        className="main-bar-top-search-input"
                        aria-label="Search"
                        value={searchValue}
                        onKeyDown={handleKeyDown}
                        onChange={(e) => setSearchValue(e.target.value)}
                    />
                </FormGroup>

                {searchValue ?
                    <Button
                        aria-label={"لغو"}
                        className="main-bar-top-search-cancel-button"
                        onClick={() => handleResetSearch()}
                    >
                        <X/>
                    </Button>
                    : null
                }
            </Form>

            {searchValue && (quickSearchResults?.length > 0 || isSearching) ?
                <div className="main-bar-top-search-quick-results">
                    {isSearching ?
                        <div className="d-flex justify-content-center py-2">
                            <Spinner/>
                        </div>
                        :
                        quickSearchResults?.map(result => (
                            <a aria-label='.' key={result.id} className="main-bar-top-search-quick-results-item" dir="rtl"
                               href={WebPaths.product(result.slug)} rel="noreferrer">
                                <div className="main-bar-top-search-quick-results-item-image">
                                    <img src={result.image.url} alt={result.image.alt}/>asasas
                                </div>
                                <div className='w-100'>
                                <span className="main-bar-top-search-quick-results-item-name d-flex align-items-start justify-content-between w-100">
                                   <span>
                                        {result.name}
                                   </span>
                                   <span>
                                        {
                                            parseInt(result.offer) !== 0  && <Chip
                                                className='main-bar-top-search-quick-results-item-name-chip'
                                                label={`${result.percent}%`}/>
                                        }
                                   </span>
                                </span>
                                    <div className="">
                                        {
                                            parseInt(result.offer) !== 0 ? <div
                                                className="d-flex align-items-end flex-column main-bar-top-search-quick-results-item-price">
                                            <span className="text-muted main-bar-top-search-quick-results-item-price-offer">
                                                {result.price}
                                                {" "}
                                                <FormattedMessage id={"Toman"}/>
                                            </span>
                                                <span>{result.first_final_price}
                                                    {" "}
                                                    <FormattedMessage id={"Toman"}/>
                                            </span>
                                            </div> : <div className="d-flex align-items-end flex-column">
                                            <span>{parseInt(result.first_final_price) === 0 ? <span className="text-muted">  <FormattedMessage id={"unavailable"}/>  </span> : <>
                                                {result.first_final_price}
                                                {" "}
                                                <FormattedMessage id={"Toman"}/>
                                            </>}</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </a>
                        ))}
                </div>
                : null
            }
        </div>
        {
            isAdvanceSearch && <FilterModal/>
        }
    </div>

    const searchbarPhone =
        <>
            <div className='main-bar-contact' onClick={openSearchHandler}>
                {isOpenSearch ? <X/> :   <BsSearch/>}
            </div>
            {
                isOpenSearch &&
                <div className={`main-bar-top-search-phone`} ref={quickSearchResultsSection}>
                    {/*<FilterModal/>*/}
                    <Form className="d-flex justify-content-start w-100" onClick={(e) => e.preventDefault()}>
                        <FormGroup className='w-100'>
                            <Input
                                type="text" //x icon not working when type is search
                                name="search"
                                placeholder="جستجوی محصول..."
                                className="main-bar-top-search-input"
                                aria-label="Search"
                                value={searchValue}
                                onKeyDown={handleKeyDown}
                                onChange={(e) => setSearchValue(e.target.value)}
                            />
                            <button
                                aria-label={"جستجو"}
                                className="main-bar-top-search-phone-btn"
                                disabled={!searchValue}
                                onClick={() => handleSearch()}
                            >
                                <BsSearch/>
                            </button>
                        </FormGroup>

                        {searchValue ?
                            <Button
                                aria-label={"لغو"}
                                className="main-bar-top-search-cancel-button"
                                onClick={() => handleResetSearch()}
                            >

                            </Button>
                            : null
                        }
                    </Form>
                    {/*   {searchValue && (quickSearchResults?.length > 0 || isSearching) ?
                    <div className="main-bar-search-quick-results">
                        {isSearching ?
                            <div className="d-flex justify-content-center py-2">
                                <Spinner/>
                            </div>
                            :
                            quickSearchResults?.map(result => (
                                <a key={result.id} className="main-bar-search-quick-results-item" dir="rtl"
                                   href={WebPaths.product(result.slug)} rel="noreferrer">
                                    <div className="main-bar-search-quick-results-item-image">
                                        <img src={result.image.url} alt={result.image.alt}/>
                                    </div>
                                    <span className="main-bar-search-quick-results-item-name">{result.name}</span>
                                </a>
                            ))}
                    </div>
                    : null
                }*/}
                </div>
            }

        </>

    const cartButton = !isAdmin &&
        <div className='d-flex align-items-center  main-bar-top-actions-bsket'>
            <button
                aria-label={"سبدخرید"}
                type="button"
                className={`w-100 main-bar-top-actions-button-cart${isMobile ? " mobile" : ""} `}
                onClick={() => navigate(WebPaths.cart)}
            >
                <div className="main-bar-top-actions-button-cart-icon">
                    <img src={basket}/>

                    {token && props.cart.count ?
                        <Badge color="danger" className="main-bar-top-actions-button-cart-icon-count">
                            {props.cart.count}
                        </Badge> : null
                    }

                </div>
                <span className="main-bar-top-actions-button-cart-title w-100">
                     <FormattedMessage id="Cart"/>
                    <DisplayPriceWithLabel
                        price={props.cart.price}
                        label="Toman"
                        isLabelSmall
                        isPriceBold
                    />

        </span>
            </button>


        </div>

    const loginButton = token ?
        <UncontrolledDropdown group className="dropdown">

            <DropdownToggle
                caret
                className={`main-bar-top-actions-button-login mr-1 p-0`}
                disabled={!props.user.fullName}
            >
                <div className="main-bar-top-actions-button-login-icon">
                    <FaRegUser/>
                </div>
            </DropdownToggle>
            <DropdownMenu>
                <DropdownItem header>
                    {props.user.fullName}
                </DropdownItem>
                <DropdownItem divider/>
                <NavLink aria-label='داشبورد' to={PanelPaths.dashboard}>
                    <DropdownItem>داشبورد</DropdownItem>
                </NavLink>
                <DropdownItem onClick={() => logoutAccount(props)}>
                    خروج از حساب
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
        :
        <button
            aria-label={"ورود&ثبت نام"}
            type="button"
            className={`main-bar-top-actions-button-login mx-1`}
            onClick={Context?.showLoginModal}
        >
            <div className="main-bar-top-actions-button-login-icon">
                <FaRegUser/>
            </div>
        </button>

    const contactMethods = useSelector(state => state.UI);

    const phonesAndMails = contactMethods.general?.social_media?.filter(contactMethod => [contactMethodsTypes.phone, contactMethodsTypes.mobile].includes(parseInt(contactMethod.type)));

    return (
        <div className="container-costumer">
            <div className='w-100 d-none d-lg-inline-block'>
                <div className="main-bar">

                    <div className='w-100 pl-1 d-flex align-items-center  w-100'>
                        <div className="d-flex align-items-md-center justify-content-center">
                            {logo}
                        </div>
                        <div className="w-100">
                            <div
                                className="main-bar-top w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap flex-column-reverse flex-md-row">
                                <div className='d-flex align-items-center'>

                                    {searchbar}
                                </div>
                                <div className="main-bar-top-actions">

                                    <div className="d-flex justify-content-start">
                                        {loginButton}
                                        {cartButton}
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex justify-content-start w-100'>
                                <Menu/>
                                <Link aria-label={'تخفیفات ویژه'} to={WebPaths.products([
                                    {
                                        param: "sort",
                                        values: productSort.specialOffer
                                    }
                                ])} className="main-bar-more-btn ml-1">
                                    %
                                    <FormattedMessage id="specialOffer"/>
                                    %
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div className='w-100 d-flex align-items-center container-costumer d-lg-none'>
                <div className="main-bar d-flex align-items-center justify-content-between">
                    <div>
                        <MobileNavbar
                            logo={logoImage}
                        />
                    </div>
                    <div className="d-flex align-items-center">
                        {logoMobile}
                    </div>


                    {searchbarPhone}

                </div>
                <Index token={token} login={Context?.showLoginModal} isAdmin={isAdmin} count={props.cart.count}/>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        user: state.auth,
        cart: state.cart
    }
};

export default connect(mapStateToProps, {handleLogout})(MainBar);